export function enableHorizontalScroll(elRef: any) {

    const el: any = elRef.current;
    if (el) {
        const onWheel = (e: any) => {
            if (e.deltaY === 0) return;
            e.preventDefault();
            el.scrollTo({
                left: el.scrollLeft + e.deltaY * 1.5,
                behavior: "smooth"
            });
        };
        el.addEventListener("wheel", onWheel);
    }
}